export default __webpack_public_path__ + "static/media/imageDesignContentFive.8b4c250c.png";